import { createStandardAction } from 'typesafe-actions'
import {
  ClickstreamSuccess,
  ContentLabel9,
  ContentTaxonomy9,
  ProductContentMetadata1,
  ProductContentMetadataWt9,
} from '../analytics/rsw/eventSchemas'

export const LINK = 'link'
export const BUTTON = 'button'
export const DROPDOWN = 'drop down'
export const COMPONENT = 'component'

export type ElementType = typeof LINK | typeof BUTTON | typeof DROPDOWN | typeof COMPONENT

export const CLICK = 'click'
export const SELECT = 'select'

export type InteractionType = typeof CLICK | typeof SELECT

export const NAV_TAB_ORIGIN = 'navtab'
export const EXPERT_CHECK_ORIGIN = 'expertcheck'
export const GRAMMAR_CARD_CTA_ORIGIN = 'grammar card cta'
export const UNSUPPORTED_CLAIMS_EC_ORIGIN = 'unsupported claims expert check cta'
export const SCORE_CARD_ORIGIN = 'score card'
export const DEMO_ORIGIN = 'demo page'
export const PLANS_ORIGIN = 'plans'

export const UNSUPPORTED_CLAIMS_REGION = 'unsupported claims cta'
export const SCORECARD_MODAL_REGION = 'scorecard modal'

export const EXPECT_CHECK_TEXT = 'Get an expert check'
export const FREE_TRIAL_TEXT = 'Start a free trial*'
export const FULL_CHECK_TEXT = 'run a full check'

type Origin =
  | typeof NAV_TAB_ORIGIN
  | typeof EXPERT_CHECK_ORIGIN
  | typeof GRAMMAR_CARD_CTA_ORIGIN
  | typeof UNSUPPORTED_CLAIMS_EC_ORIGIN
  | typeof SCORE_CARD_ORIGIN
  | typeof DEMO_ORIGIN
  | typeof PLANS_ORIGIN

export const EXPERT_CHECK_CTA_ELEMENT = 'expert check cta'
export const EXPERT_CHECK_RESUBMIT_ELEMENT = 'expert check paper resubmit'
export const EXPERT_CHECK_FEEDBACK_ELEMENT_NAME = 'expert check feedback section'
export const EXPERT_CHECK_NOTES_ELEMENT_NAME = 'expert check feedback notes'

export const UPLOAD_PAPER_ELEMENT_NAME = 'upload paper'
export const SUBMIT_PAPER_ELEMENT_NAME = 'submit paper'
export const START_FREE_TRIAL_ELEMENT_NAME = 'start free trial'
export const START_SUBSCRIPTION_ELEMENT_NAME = 'start subscription'
export const EDIT_YOUR_PAPER_ELEMENT_NAME = 'edit your paper'
export const SUBMIT_EXPERT_CHECK_ELEMENT_NAME = 'submit expert check'
export const UPLOAD_A_DIFFERENT_PAPER_ELEMENT_NAME = 'upload a different paper'
export const PLANS_PAGE_SIGNUP_ELEMENT = 'sign up'
export const GATING_CTA_ELEMENT_NAME = 'full feedback paywall upsell cta'
export const EC_FEEDBACK_UNLOCK_ELEMENT = 'full feedback module upsell'

export interface ClickstreamInteractionPayload {
  origin: Origin
  element: string
  region?: string
  text?: string
  type: ElementType
  value?: string
  interactionType: InteractionType
  metadata?: ProductContentMetadata1
}

export const USER_INTERACTION = 'user/INTERACTION'
export const USER_NOTIFY = 'user/NOTIFY'
export const USER_COMPONENT_VIEW = 'user/COMPONENT_VIEW'
export const USER_SUCCESS = 'user/SUCCESS'

export const userInteract = createStandardAction(USER_INTERACTION)<
  ClickstreamInteractionPayload
>()

const info = 'info'
const error = 'error'

type NotificationType = typeof info | typeof error
export interface ClickstreamNotificationPayload {
  type: NotificationType
  message: string
}

export const userNotify = createStandardAction(USER_NOTIFY)<
  ClickstreamNotificationPayload
>()

export interface ClickstreamComponentViewPayload {
  name: string
  value?: string
  text?: string
  index?: number
}

export const userComponentView = createStandardAction(USER_COMPONENT_VIEW)<
  ClickstreamComponentViewPayload
>()

export type SubjectTaxonomy = ContentTaxonomy9['subjects']
export type PaperMetadata = ProductContentMetadataWt9['writing']
export type ClickstreamSuccessState = ClickstreamSuccess['data']['state']

export interface ClickstreamSuccessPayload {
  name: string
  state?: ClickstreamSuccessState
  content_id?: string
  content_label?: ContentLabel9
  metadata?: PaperMetadata
  subjectTaxonomy?: SubjectTaxonomy
}

export const userSuccess = createStandardAction(USER_SUCCESS)<ClickstreamSuccessPayload>()



// WEBPACK FOOTER //
// ./src/state/userevents/actions.ts